import { SelectInputData } from "@src/components/deprecated/SelectInputField/SelectInputField";
import { translate } from "../../../libs/i18next/translations.util";
import { Tag } from "./tags.type";
import { IRawCompanyTag } from "@propely/propely-typings";
import { TFunction, t } from "i18next";

export const getUniqueTagArray = (tags: Tag[]) => {
  // Remove duplicate IDs based on the 'id' property
  return [...new Set(tags.map((tag) => tag.id))].map((id) => {
    return tags.find((tag) => tag.id === id)!;
  });
};

export const formatTagName = ({ badgeIcon, name }: Tag | IRawCompanyTag): string => {
  return (badgeIcon ? `${badgeIcon} ` : "") + translate(name);
};

export const formatSelectedTagNames = ({ tags, selectedTagIds, fallbackText }: { tags: Tag[]; selectedTagIds: string[]; fallbackText: string }) => {
  return selectedTagIds && selectedTagIds.length > 0
    ? selectedTagIds
        ?.map((tagID) => {
          const tag = tags?.find((tag) => tag.id === tagID);
          return tag ? formatTagName(tag) : "";
        })
        .join(",")
    : fallbackText;
};

export const mapTagsToOptions = (tags: Tag[]) => {
  return tags.map((tag) => {
    return new SelectInputData(tag?.id, formatTagName(tag));
  });
};

export const getTagWithId = (tagList: Tag[], id: string): Tag => {
  return tagList.find((tag) => tag.id === id) ?? tagList[0];
};

export const sortTagsByDate = (tagA: Tag | IRawCompanyTag, tagB: Tag | IRawCompanyTag) => {
  const createdDateA = tagA.createdBy?.date;
  const createdDateB = tagB.createdBy?.date;

  // Convert to numbers directly; undefined will be NaN
  const dateANum = Number(createdDateA);
  const dateBNum = Number(createdDateB);

  // If both dates are NaN (undefined), return 0
  if (isNaN(dateANum) && isNaN(dateBNum)) {
    return 0;
  }

  // If only one date is NaN, the other should come first
  if (isNaN(dateANum)) {
    return -1;
  }
  if (isNaN(dateBNum)) {
    return 1;
  }

  // If both dates are valid, compare them directly
  return dateBNum - dateANum;
};

